import axios from "axios";
import store from "@/store";
import router from '@/router/index'

export default {
  state: {
    trainerSessionAll: [],
    trainerSessionView: [],
    trainerSessionList: [],
    findSessionsList: [],
    userSessionDetail: [],
    userSessionJoin: [],
    trainerSessionUpdateslot: [],
    trainerBatchDelete: [],
    trainerSessionSchedule: [],
    trainerSessionDelete: [],
    trainerSessionUpdate: [],
    trainerSessionCreate: [],
    userSessionAll: [],
    images: [],
    userAddMoney: [],
    difficultiesList: [],
    languagesList: [],
    trainerUpcomingSessions: [],
    filterCategoriesList: [],
    trainerCalenderSessionsList: [],
    searchedTrainerUserList: [],
    userReportingReasons: [],
    userReport: [],
    userDataPrivateSession: [],
    topSessionList: [],
    categorySessionList: [],
    languageSessionList: [],
    checkPaymentEnableOrDisable: [],
    postUserSessionAddRemoveFavourite: [],
    userSessionFavourite: [],
    oauth: [],
    syncOff: [],
    syncStatus: []
  },

  getters: {
    syncStatus(state) {
      return state.syncStatus
    },
    oauth(state) {
      return state.oauth
    },
    syncOff(state) {
      return state.syncOff
    },
    checkPaymentEnableOrDisable(state) {
      return state.checkPaymentEnableOrDisable;
    },
    languageSessionList(state) {
      return state.languageSessionList;
    },
    categorySessionList(state) {
      return state.categorySessionList;
    },
    topSessionList(state) {
      return state.topSessionList;
    },
    trainerUpcomingSessions(state) {
      return state.trainerUpcomingSessions;
    },
    languagesList(state) {
      return state.languagesList;
    },
    difficultiesList(state) {
      return state.difficultiesList;
    },
    userAddMoney(state) {
      return state.userAddMoney;
    },
    images(state) {
      return state.images;
    },
    userSessionAll(state) {
      return state.userSessionAll;
    },
    trainerSessionAll(state) {
      return state.trainerSessionAll;
    },
    trainerSessionView(state) {
      return state.trainerSessionView;
    },
    trainerSessionList(state) {
      return state.trainerSessionList;
    },
    findSessionsList(state) {
      return state.findSessionsList;
    },
    userSessionDetail(state) {
      return state.userSessionDetail;
    },
    userSessionJoin(state) {
      return state.userSessionJoin;
    },
    trainerSessionUpdateslot(state) {
      return state.trainerSessionUpdateslot;
    },
    trainerBatchDelete(state) {
      return state.trainerBatchDelete;
    },
    trainerSessionSchedule(state) {
      return state.trainerSessionSchedule;
    },
    trainerSessionDelete(state) {
      return state.trainerSessionDelete;
    },
    trainerSessionUpdate(state) {
      return state.trainerSessionUpdate;
    },
    trainerSessionCreate(state) {
      return state.trainerSessionCreate;
    },
    filterCategoriesList(state) {
      return state.filterCategoriesList;
    },
    trainerCalenderSessionsList(state) {
      return state.trainerCalenderSessionsList;
    },
    searchedTrainerUserList(state) {
      return state.searchedTrainerUserList;
    },
    userReportingReasons(state) {
      return state.userReportingReasons;
    },
    userReport(state) {
      return state.userReport;
    },
    userDataPrivateSession(state) {
      return state.userDataPrivateSession;
    },
    postUserSessionAddRemoveFavourite(state) {
      return state.postUserSessionAddRemoveFavourite
    },
    userSessionFavourite(state) {
      return state.userSessionFavourite
    },
  },

  actions: {
    async getTrainerSessionView({ commit }, { id, query }) {
      let res = null;
      if (query) {
        res = await axios.get(`trainer/session/view/${id}`, {
          params: query,
        });
      } else {
        res = await axios.get(`trainer/session/view/${id}`);
      }

      const data = res && res.data && res.data.data;
      commit("setTrainerSessionView", data);
    },

    async getTrainerSessionAll({ commit }) {
      try {
        const res = await axios.get("trainer/session/all");
        const data = res && res.data && res.data.data;
        commit("setTrainerSessionAll", data);
      } catch (err) {
        console.log(err)
        throw err;
      }
    },

    async getTrainerUpcomingSessions({ commit }, { query }) {
      commit("loadingStatus", true);

      await axios
        .get(`trainer/upcoming/sessions/${query.per_page}`, {
          params: { page: query.page },
        })
        .then((res) => {
          commit("setTrainerUpcomingSessions", (res && res.data) || {});
          commit("loadingStatus", false);
        })
        .catch((e) => {
          commit(
            "setTrainerUpcomingSessions",
            (e.response && e.response.data) || {}
          );
          commit("loadingStatus", false);
        });
    },

    async getUserSessionAll({ commit }) {
      try {
        const res = await axios.get("user/session/all");
        const data = res && res.data && res.data.data;
        commit("setUserSessionAll", data);
      } catch (err) {
        console.log(err);
        throw err;
      }
    },

    async trainerSessionCreate({ commit }, payload) {
      store.commit("setIsLoading", true);
      try {
        const res = await axios.post("trainer/session/create", payload.data);
        store.commit("setIsSuccess", res && res.data && res.data.message);
        payload && payload.submitAction && payload.submitAction === 'exit' ? commit("setTrainerSessionCreateExit", res && res.data && res.data.data) : commit("setTrainerSessionCreate", res && res.data && res.data.data)
        store.commit("setIsLoading", false);
      } catch(err) {
        store.commit('setIsLoading', false)
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
      
    },

    async postOauth({ commit }, payload) {
      try {
        const res = await axios.post("oauth", payload);
        store.commit("setIsSuccess", res && res.data && res.data.message);
        const data = res && res.data && res.data.data;
        commit("setPostOauth", data);
      } catch(err) {
        commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err
      }
    },

    async getSyncOff({ commit }) {
      const res = await axios.get("sync-off");

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const data = res && res.data && res.data.data;
      commit("setSyncOff", data);
    },

    async getSyncStatus({ commit }) {
      const res = await axios.get("sync-status");

      const data = res && res.data && res.data.data;
      commit("setSyncStatus", data);
    },

    async getTrainerSessionList({ commit }, { id, query = "" }) {
      commit("loadingStatus", true);

      var url =
        id == "all" ? `trainer/session/list` : `trainer/session/list/${id}`;
      await axios
        .get(url, { params: query || {} })
        .then((res) => {
          commit("setTrainerSessionList", (res && res.data) || {});
          commit("loadingStatus", false);
        })
        .catch((e) => {
          commit(
            "setTrainerSessionList",
            (e.response && e.response.data) || {}
          );
          commit("loadingStatus", false);
        });
    },

    async getTrainerCalenderSessionsList({ commit }, { payload, query = "" }) {
      try {
        const res = await axios.post("search/calender", payload, {
          params: query,
        });
  
        const data = res && res.data && res.data.data;
        commit("setTrainerCalenderSessionsList", data);
      } catch (e) {
        console.log(e)
      }
    },

    async trainerSessionUpdate({ commit }, data) {
      store.commit("setIsLoading", true);
      let id = "";
      for (var pair of data.entries()) {
        if (pair[0] == "id") {
          id = pair[1];
        }
      }
      try {
        const res = await axios.post(`trainer/session/update/${id}`, data);
        store.commit("setIsSuccess", res && res.data && res.data.message);
        const newData = res && res.data && res.data.data;
        commit("setTrainerSessionUpdate", newData);
        store.commit("setIsLoading", false);
      } catch(err) {
        store.commit('setIsLoading', false)
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err;
      }
    },

    async trainerSessionSchedule({ commit }, data) {

      const res = await axios.post(`trainer/session/schedule/${data.id}`, data);
      store.commit("setIsSuccess", res && res.data && res.data.message);

      const newData = res && res.data && res.data.data;
      commit("setTrainerSessionSchedule", newData);
    },

    async trainerCourseSchedule({ commit }, data) {
      const res = await axios.post(`trainer/course/schedule/${data.id}`, data);
      store.commit("setIsSuccess", res && res.data && res.data.message);

      const newData = res && res.data && res.data.data;
      commit("setTrainerSessionSchedule", newData);
    },

    async trainerSessionUpdateslot({ commit }, session) {
      const res = await axios.post(
        `trainer/session/updateslot/${session.id}`,
        session
      );

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const newData = res && res.data && res.data.data;
      commit("setTrainerSessionUpdateslot", newData);

    },

    async trainerSessionDelete({ commit }, id) {
      const res = await axios.post(`trainer/session/delete/${id}`);

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const data = res && res.data && res.data.data;
      commit("setTrainerSessionDelete", data);
    },

    async trainerBatchDelete({ commit }, id) {
      try {
        const res = await axios.post(`trainer/batch/delete/${id}`);
        store.commit("setIsSuccess", res && res.data && res.data.message);
        commit("setTrainerBatchDelete", id);
      } catch(err) {
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err
      }
    },

    async getFindSessionsList({ commit }, { query, payload = {} }) {
      commit("loadingStatus", true);

      await axios
        .post("search/session", payload, { params: query || {} })
        .then((res) => {
          commit("setFindSessionsList", (res && res.data) || {});
          commit("loadingStatus", false);
        })
        .catch((e) => {
          commit("setFindSessionsList", (e.response && e.response.data) || {});
          commit("loadingStatus", false);
          throw e;
        });
    },

    async getUserSessionDetail({ commit }, id) {
      const res = await axios.get(`user/session/detail/${id}`);

      const data = res && res.data && res.data.data;
      commit("setUserSessionDetail", data);
    },

    async getUserSessionDetailMore({ commit }, id) {
      try {
        const res = await axios.get(`user/session/detail/${id}`);
        const data = res && res.data && res.data.data;
        commit("setUserSessionDetailMore", data);
      } catch(err) {
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err
      }
    },
    async getUserSessionDetailLess({ commit }, id) {
      const res = await axios.get(`user/session/detail/${id}`);

      const data = res && res.data && res.data.data;
      commit("setUserSessionDetailLess", data);
    },

    async userSessionJoin({ commit }, data) {
      const res = await axios.post(`user/session/join`, data);
      store.commit("setIsSuccess", res && res.data && res.data.message);

      const newData = res && res.data && res.data.data;
      commit("setUserSessionJoin", newData);
    },

    async searchTrainerUserList({ commit }, { payload, query }) {
      const res = await axios.post(`search/user`, payload, { params: query });

      const data = res && res.data && res.data.data;
      commit("setSearchedTrainerUserList", data);
    },

    async getImages({ commit }, categoryId) { // duplicate
      const res = await axios.get(`get/images/${categoryId}/5`);

      const data = res && res.data && res.data.data;
      commit("setImages", data);
    },

    async getSessionImages({ commit }, categoryId) {
      const res = await axios.get(`get/images/${categoryId}/5`);

      const data = res && res.data && res.data.data;
      commit("setImages", data);
    },

    async getImagesSearch({ commit }, categoryId) {
      const res = await axios.get(`get/images/${categoryId}/50`);

      const data = res && res.data && res.data.data;
      commit("setImages", data);
    },

    async getDifficultiesList({ commit }) {
      const res = await axios.get("difficulties");

      const data = res && res.data && res.data.data;
      commit("setDifficultiesList", data);
    },

    async getLanguagesList({ commit }) {
      try {
        const res = await axios.get("languages");
        const data = res && res.data && res.data.data;
        commit("setLanguagesList", data);
      } catch(err) {
        store.commit('setIsLoading', false)
        store.commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
      }
    },

    async userAddMoney({ commit }) {
      const res = await axios.post(`user/add/money`);

      const data = res && res.data && res.data.data;
      commit("setUserAddMoney", data);
    },

    async getFilterCategoriesList({ commit }) {
      const res = await axios.get(`categories`);

      const data = res && res.data && res.data.data;
      commit("setFilterCategoriesList", data);
    },

    async getUserReportingReasons({ commit }, payload) {
      const res = await axios.post(`/reporting-reasons`, payload);

      const data = res && res.data && res.data.data;
      commit("setUserReportingReasons", data);
    },

    async makeReport({ commit }, payload) {
      const res = await axios.post(`report/abuse`, payload);

      store.commit("setIsSuccess", res && res.data && res.data.message);

      const data = res && res.data && res.data.data;
      commit("setUserReport", data);

    },

    async getUserDataPrivateSession({ commit }, ModalId) {
      const res = await axios.get(`trainer/session/private/data/${ModalId}`);

      const data = res.data.data;
      commit("setUserDataPrivateSession", data);
    },

    async postTopSessionList({ commit }, data) {
      await axios
        .post('search/session', data)
        .then((res) => {
          commit("setTopSessionList", (res && res.data && res.data.data) || {});
        })
        .catch((e) => {
          commit(
            "setTopSessionList",
            (e.response && e.response.data) || {}
          );
          throw e
        });
    },

    async postCategorySessionList({ commit }, data) {
      await axios
        .post('search/session', data)
        .then((res) => {
          commit("setCategorySessionList", (res && res.data && res.data.data) || {});
        })
        .catch((e) => {
          commit(
            "setCategorySessionList",
            (e.response && e.response.data) || {}
          );
          throw e
        });
    },

    async postLanguageSessionList({ commit }, data) {
      await axios
        .post('search/session', data)
        .then((res) => {
          commit("setLanguageSessionList", (res && res.data && res.data.data) || {});
        })
        .catch((e) => {
          commit(
            "setLanguageSessionList",
            (e.response && e.response.data) || {}
          );
          throw e;
        });
    },

    async getCheckPaymentEnableOrDisable({ commit }) {
      const res = await axios.get(`admin/settings`);
      let data = JSON.parse(res && res.request && res.request.response)
      commit("setCheckPaymentEnableOrDisable", data.data);
    },

    async postUserSessionAddRemoveFavourite({ commit }, payload) {
      try {
        const res = await axios.post(`user/session/add-remove-favourite`, payload);
        const data = res && res.data && res.data.data;
        commit("setPostUserSessionAddRemoveFavourite", data);
        if (data && data.is_favourite && data.is_favourite === 'yes') {
          store.commit("setIsSuccess", "Session added to favourites");
        } else {
          store.commit("setIsSuccess", "Session removed from favourite");
        }
      } catch(err) {
        commit('setError', {title: "Alert", text: err.response && err.response.data.message || err.message})
        throw err
      }
    },

    async getUserSessionFavourite({ commit }, payload) {
      const res = await axios.post(`user/session/favourite`, {
        params: payload
      });

      const data = res && res.data && res.data.data;
      commit("setUserSessionFavourite", data);
    },
    async getZoomSignature({ commit }, payload) {
      try {
        const res =  await axios.post(window.config.VUE_APP_ZOOM_SIGNATURE_ENDPOINT, payload)
        return res && res.data
      } catch (err) {
        throw err; // Propagate the error to the calling function
      }
    }
  },

  mutations: {
    setCheckPaymentEnableOrDisable(state, data) {
      state.checkPaymentEnableOrDisable = data;
    },
    setLanguageSessionList(state, data) {
      state.languageSessionList = data;
    },
    setCategorySessionList(state, data) {
      state.categorySessionList = data;
    },
    setTopSessionList(state, data) {
      state.topSessionList = data;
    },
    setCategoriesList(state, data) {
      state.categoriesList = data;
    },
    setLanguagesList(state, data) {
      state.languagesList = data;
    },
    setDifficultiesList(state, data) {
      state.difficultiesList = data;
    },
    setUserAddMoney(state, data) {
      state.userAddMoney = data;
    },
    setImages(state, data) {
      state.images = data;
    },
    setSearchedTrainerUserList(state, data) {
      state.searchedTrainerUserList = data;
    },
    setTrainerUpcomingSessions(state, data) {
      state.trainerUpcomingSessions = data;
    },
    setTrainerSessionAll(state, data) {
      let arr = [];
      data.map((d) => {
        arr.push({
          id: d.id,
          title:
            d.entity_type == 1 ? d.title : d.title + " - " + d.course_title,
          tooltip:
            d.entity_type == 1 ? "Session: " + d.title : "Course: " + d.course_title,
          description: d.description,
          startRecur: d.start_date,
          endRecur: d.end_date,
          startTime: d.start_date,
          endTime: d.end_date,
          allDay: false,
          sessionId: d.session_id,
          courseId: d.course_id,
          isPrivate: d.is_private,
          isCourse: d.is_course_batch,
          timezone: d.timezone,
          color: "#FDFDFD",
          // borderColor: d.is_private == 1 ? "#F5DCFA" : d.entity_type == 1 ? "#87CEFA" : '#364B69',
          borderColor: d.status == 3 ? "#FDFDFD" : d.entity_type == 1 ? "#87CEFA" : '#364B69',
          textColor: "black",
          thumbnailUrl:
            d.entity_type == 1 ? d.thumbnail_url : d.course_thumbnail_url,
          cost: d.cost,
          // imageurl:
          //   d.entity_type == 1
          //     ? process.env.VUE_APP_BASE_URL + d.thumbnail_url
          //     : process.env.VUE_APP_BASE_URL + d.course_thumbnail_url,
          category: d.category,
          status: d.status,
          meeting_id: d.meeting_id,
          start_meeting_link: d.start_meeting_link,
          isBooked: d.is_booked
        });
      });
      state.trainerSessionAll = arr;
    },

    setUserSessionAll(state, data) {
      let arr = [];
      data.map((d) => {
        arr.push({
          id: d.id,
          title:
            d.entity_type == 1 ? d.title : d.title + " - " + d.course_title,
          description: d.description,
          startRecur: d.start_date,
          endRecur: d.end_date,
          startTime: d.start_date,
          endTime: d.end_date,
          allDay: false,
          sessionId: d.session_id,
          courseId: d.course_id,
          isPrivate: d.is_private,
          isCourse: d.is_course_batch,
          color: "#FDFDFD",
          borderColor: d.status === 0 ? 'red' : (d.is_private == 1 ? "#F5DCFA" : "#87CEFA"),
          textColor: "black",
          thumbnailUrl:
            d.entity_type == 1 ? d.thumbnail_url : d.course_thumbnail_url,
          cost: d.cost,
          category: d.category,
          status: d.status,
          meeting_id: d.meeting_id,
          meeting_link: d.meeting_link
        });
      });
      state.userSessionAll = arr;
    },

    setTrainerSessionSchedule(state, data) {
      data.map((d) => {
        state.trainerSessionAll.push({
          id: d.id,
          title:
            d.entity_type == 1 ? d.title : d.title + " - " + d.course_title,
          description: d.description,
          startRecur: d.start_date,
          endRecur: d.end_date,
          startTime: d.start_date,
          endTime: d.end_date,
          allDay: false,
          sessionId: d.session_id,
          courseId: d.course_id,
          isPrivate: d.is_private,
          isCourse: d.is_course_batch,
          // color: d.is_private == 1 ? "darkblue" : "",
          color: "#FDFDFD",
          borderColor: d.is_private == 1 ? "#F5DCFA" : d.entity_type == 1 ? "#87CEFA" : '#364B69',
          textColor: "black",
          thumbnailUrl:
            d.entity_type == 1 ? d.thumbnail_url : d.course_thumbnail_url,
          cost: d.cost,
          category: d.category,
        });
      });
      router.push({ name: "TrainerCalendar" });
      location.reload()
    },

    setTrainerSessionList(state, data) {
      state.trainerSessionList = data;
    },
    setTrainerCalenderSessionsList(state, data) {
      state.trainerCalenderSessionsList = data;
    },
    setFindSessionsList(state, data) {
      state.findSessionsList = data;
    },
    setUserSessionJoin(state, data) {
      state.userSessionJoin = data;
    },
    setUserSessionDetail(state, data) {
      state.userSessionDetail = data;
    },
    setUserSessionDetailMore(state, data) {
      // state.userSessionDetail = data
      state.userSessionDetail.batches.available.next_page_url =
        data.batches.available.next_page_url;
      data.batches.available.data.map((d) => {
        state.userSessionDetail.batches.available.data.push(d);
      });
    },

    setUserSessionDetailLess(state, data) {
      // state.userSessionDetail = data
      state.userSessionDetail.batches.available.next_page_url =
        data.batches.available.next_page_url;
      state.userSessionDetail.batches.available.data = state.userSessionDetail.batches.available.data.slice(0, 3);
    },

    setTrainerSessionUpdateslot(state, newData) {
      state.trainerSessionUpdateslot = newData;
    },
    setTrainerBatchDelete(state, data) {
      // state.trainerBatchDelete = data;
      // const index = state.trainerSessionAll.findIndex((e) => e.id == data);
      // if (index !== -1) {
      //   state.trainerSessionAll.splice(index, 1);
      // }
      state.trainerSessionAll = data
    },

    setTrainerSessionDelete(state, data) {
      state.trainerSessionDelete = data;
    },
    setTrainerSessionUpdate(state, data) {
      state.trainerSessionUpdate = data;
    },
    setTrainerSessionCreate(state, data) {
      state.trainerSessionCreate = data;
      // router.push({ name: "session", params: { id: data.id } });
      router.push({
        name: "TrainerCalendar",
        query: {
          id: data && data.id,
          title: data && data.title,
          type: data && data.entity_type,
          url: data && data.thumbnail_url,
          sessions: null,
        },
      })
    },
    setTrainerSessionCreateExit(state, data) {
      router.push({ name: "session", params: { id: data.id } });
    },

    setPostOauth(state, data) {
      state.oauth = data
    },
    setSyncOff(state, data) {
      state.syncOff = data
    },
    setSyncStatus(state, data) {
      state.syncStatus = data
    },
    setTrainerSessionView(state, data) {
      state.trainerSessionView = data;
    },
    setFilterCategoriesList(state, data) {
      state.filterCategoriesList = data;
    },
    setUserReportingReasons(state, data) {
      state.userReportingReasons = data;
    },
    setUserReport(state, data) {
      state.userReport = data;
    },
    setUserDataPrivateSession(state, data) {
      let arr = [];
      for (let i = 0; i < data.length; i++) {
        let user = {};
        user.id = data[i].id;
        user.name = data[i].name;
        user.email = data[i].email;
        arr.push(user);
      }
      state.userDataPrivateSession = arr;
    },

    setPostUserSessionAddRemoveFavourite(state, data) {
      state.postUserSessionAddRemoveFavourite = data
    },
    setUserSessionFavourite(state, data) {
      state.userSessionFavourite = data
    },
  },
};